import { IconProps } from 'shared/components/Icons/types/IconProps'
import { colors } from 'shared/lib'

export const UnderRetailArrow = ({
  color = colors.FC2_RED,
  width = '6',
  height = '6',
  fill = 'var(--fc-red, #E91C23)',
  viewBox = '0 0 6 6',
}: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox={viewBox}
    fill={fill}
  >
    <path
      d="M5.44418 4.95616L5.44349 5.4568L4.94423 5.45611L0.000701195 5.44989V4.45L3.74685 4.45483L1.06608e-05 0.707997L0.707117 0.000890383L4.44567 3.73944L4.4505 0.000199849H5.4504L5.44418 4.95616Z"
      fill={color}
    />
  </svg>
)
